import React from 'react';
import styled from 'styled-components';

const NavWrapper = ({ children, isSmallScreen }: { children: React.ReactNode; isSmallScreen: boolean }) =>
	isSmallScreen ? <MobileMenuContainer children={children} /> : <DesktopMenuContainer children={children} />;

export default NavWrapper;

const DesktopMenuContainer = styled.div`
	position: absolute;
	right: 0;
	top: 40px;
	width: 350px;
	transform-origin: top right;
	z-index: 50;
	border-radius: 5px;
	color: ${({ theme }) => theme.colors.white};
	background-color: ${({ theme }) => theme.colors.darkGreyR};
	box-shadow: 1px 1px 10px ${({ theme }) => theme.colors.shadow};
	overflow: hidden;
`;

const MobileMenuContainer = styled.div`
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	top: 0;
	height: 100%;
	width: 100%;
	margin-top: 50px;
	margin-bottom: 20px;
	color: ${({ theme }) => theme.colors.white};
	background-color: ${({ theme }) => theme.colors.darkR};
	overflow: auto;
`;
